<div class="bm--auth-form-box check-email-page">
  <h1 class="common-section-title common-section-title--form">Check email</h1>

  <img
    [src]="'assets/images/icons/envelope.svg' | bmAssetUrl"
    alt="envelope icon"
    class="check-email-page__message-icon"
  />

  <p class="bm--auth-form__hint check-email-page__hint">{{ message }}</p>

  <div class="bm--auth-form-btn-container">
    <bmcore-button title="Back to Sign In" styleName="center" routerPath="/sign-in"> </bmcore-button>
  </div>
</div>
